<div class="container">
  <div class="content">
    <h1>Contact Me for any Questions!</h1>
    <form [formGroup]="message" (ngSubmit)="send()">
      <mat-form-field>
        <mat-label>Name</mat-label>
        <input
          matInput
          required
          name="name"
          type="text"
          formControlName="name"
        />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Email</mat-label>
        <input
          matInput
          required
          name="email"
          type="email"
          formControlName="email"
        />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Message</mat-label>
        <textarea
          matInput
          required
          name="message"
          formControlName="msg"
        ></textarea>
      </mat-form-field>
      <button mat-raised-button class="button" type="submit">Send</button>
    </form>
  </div>
</div>
